'use client'

import { Link } from 'react-router-dom'
import { Cog6ToothIcon } from '@heroicons/react/24/outline'
import React, { useCallback } from 'react'
import { LogOut } from 'lucide-react'

import { Logo } from 'ui/Logo/Logo'
import { InstalledSoftwareRoutePath, DownloadsRoutePath } from 'router'
import { AdminIndexPath } from 'features/admin/routes'
import { useAuthStore } from 'features/auth/useAuthStore'
import { useShowAuthModal } from 'features/auth/AuthModalOverlay'
import { isRunningInElectron } from 'utils/electron'
import { BlinkingDot } from 'ui/components/BlinkingDot'

const NavLink = ({ href, children }: { href: string; children: React.ReactNode }) => (
  <Link to={href} className="text-sm  leading-6 text-gray-900 hover:underline">
    {children}
  </Link>
)

export function TopNavBar() {
  const user = useAuthStore((state) => state.user)

  return (
    <header className="bg-white">
      <nav aria-label="Global" className="mx-auto flex items-center justify-between p-4 lg:px-6">
        <div className="flex items-center gap-x-12">
          <Link to="/">
            <Logo className="w-48 h-auto" />
          </Link>
          <div className="hidden lg:flex lg:gap-x-12">
            <NavLink href="/">Store</NavLink>
            {isRunningInElectron && <NavLink href={InstalledSoftwareRoutePath()}>Installed</NavLink>}
            {isRunningInElectron && false && (
              // temporary disabled since we can't deploy the app :(
              <div className="flex items-center whitespace-nowrap">
                <BlinkingDot />
                <NavLink href={DownloadsRoutePath()}>Downloads</NavLink>
              </div>
            )}

            {user?.isStaff && <NavLink href={AdminIndexPath()}>Admin</NavLink>}
          </div>
        </div>
        <div className="flex items-center gap-x-4 text-xs font-light leading-6">
          <Link to="/settings/" className="text-sm  leading-6 text-gray-900">
            <Cog6ToothIcon className="w-4 h-auto " />
          </Link>
          {/*<a*/}
          {/*  href="http://headwayapp.co/presync-changelog"*/}
          {/*  target="_blank"*/}
          {/*  className="hover:bg-gray-100 rounded py-1 text-gray-400 px-2 -mx-2 cursor-pointer inline-block flex"*/}
          {/*>*/}
          {/*  <span className="inline-block flex-grow">Changelog</span>*/}
          {/*</a>*/}

          <TopNavBarUserBlock />
          {/* <NavLink href="#">
            Log in <span aria-hidden="true">&rarr;</span>
          </NavLink> */}
        </div>
      </nav>
    </header>
  )
}

export const TopNavBarUserBlock = React.memo(() => {
  const user = useAuthStore((state) => state.user)
  const logout = useAuthStore((state) => state.logout)
  const asyncShowLoginForm = useShowAuthModal()
  const showLoginForm = useCallback(() => {
    asyncShowLoginForm().then()
  }, [asyncShowLoginForm])

  if (!user)
    return (
      <div className="text-xs" style={{ fontSize: '0.7rem' }}>
        <div className="flex items-center gap-x-2 end py-2">
          <a href="#" className="hover:underline" onClick={showLoginForm}>
            Sign In
          </a>
        </div>
      </div>
    )
  return (
    <div className="text-sm">
      <div className="flex items-center gap-x-4 text-[0.7rem] leading-6">
        <div aria-hidden="true" className="truncate w-full">
          {user.email}
        </div>
        <a href="#" onClick={logout} className="">
          <LogOut className="w-4 height-auto  " />
        </a>
      </div>
    </div>
  )
})
